import styled, {css, DefaultTheme} from 'styled-components'

export const StyledLayout = styled.div(
    ({isLight = true, theme: {palette}}: {isLight?: boolean; theme: DefaultTheme}) => css`
        height: 100%;
        background-color: ${isLight ? palette.neutral.white : palette.primary[900]};
        color: ${isLight ? palette.primary[900] : palette.neutral.white};
    `
)
